export enum LineFragmentType {
  TEXT,
  IN,
  AS,
  TO,
  CHANGE_TO,
}

export class LineFragment {
  type: LineFragmentType;
  value?: string; // only for text

  constructor(translationFragment: string) {
    switch (translationFragment) {
      case '{publicOrPrivate}':
        this.type = LineFragmentType.IN;
        break;
      case '{brand}':
        this.type = LineFragmentType.AS;
        break;
      case '{customerName}':
        this.type = LineFragmentType.TO;
        break;
      case '{andXMore}':
        this.type = LineFragmentType.CHANGE_TO;
        break;
      default:
        this.type = LineFragmentType.TEXT;
        this.value = translationFragment;
    }
  }
}
